import { AeoRecommendationSchema } from "@redotech/redo-model/aeo/aeo-recommendation";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export enum AeoRecommendationGenerationStatus {
  GENERATING = "generating",
  NOT_ENOUGH_DATA = "not_enough_data",
}
const AeoRecommendationGenerationStatusSchema = createEnum(
  AeoRecommendationGenerationStatus,
);

export const getAeoRecommendations = {
  name: "getAeoRecommendations" as const,
  input: z.object({}),
  output: z.object({
    recommendations: z.array(AeoRecommendationSchema),
    generationStatus: AeoRecommendationGenerationStatusSchema.optional(),
  }),
};
